<div class="header-top" *ngIf="Service =='BookAppointment' ">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-sm-4 col-lg-4 text-center">
                <div class="header-top-item">
                    <div class="header-top-left">
                        <ul>
                            <li>
                                <app-language></app-language>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="signup-area" style="margin: 50px 0px ;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 pl-0">
                <div class="signup-left">
                    <!-- <img src="assets/img/signup-bg.jpg" alt="SignUp"> -->
                </div>
            </div>
            <div *ngIf="Patient" class="col-lg-6 ptb-100">
                <div class="signup-item">
                    <div class="signup-head">
                        <h3>{{'AUTH.REGISTER.DESC' | translate}}</h3>
                        <p>{{'AUTH.GENERAL.HAVE_ACCOUNT' | translate}} <a routerLink="/login">{{'AUTH.LOGIN.TITLE' |
                                translate}}</a></p>
                                <p  *ngIf="Service !='BookAppointment' ">{{ language == 'en'? 'You have no data?':'لا توجد لك بيانات ؟' }} <a style="cursor: pointer;color: rgb(182 142 39);" (click)="ShowGuestForm()">{{ language == 'en'? 'Register for the first time':'التسجيل لاول مرة'}}</a></p>
                    </div>
                    <div class="signup-form">
                        <form class="login-form" [formGroup]="signUpForm" >
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSPORTNO' | translate}}"
                                            formControlName="PassportNo" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'PassportNo',signUpForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" class="text-danger" *ngIf="!signUpForm.get('PassportNo').valid && signUpForm.get('PassportNo').touched">
                                            {{ language == 'en'? 'You must enter a valid National ID / Iqama (8-15) Characters':'يجب ادخال رقم هوية صحيح (8-15) حرفًا'}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="number" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PHONENUMBER' | translate}}"
                                            formControlName="Mobile" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Mobile',signUpForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="controlHasError('pattern', 'Mobile',signUpForm)">
                                            {{ 'AUTH.VALIDATION.MOBILE_VALIDATION'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSWORD' | translate}}"
                                            formControlName="Password">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Password',signUpForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="!signUpForm.get('Password').valid && signUpForm.get('Password').touched">
                                            {{ 'AUTH.VALIDATION.PASSWORDCONS'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.CONFIRM_PASSWORD' | translate}}"
                                            formControlName="ConfirmPassword" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'ConfirmPassword',signUpForm)  && isControlTouched('ConfirmPassword',signUpForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        
                                        <ng-container
                                            *ngIf="signUpForm.controls['ConfirmPassword'].errors &&
                                      signUpForm.controls['ConfirmPassword'].errors.ConfirmPassword && isControlTouched('ConfirmPassword',signUpForm)">
                                            <div class="text-danger">
                                                {{ 'AUTH.VALIDATION.DIDNOTMATCH_FIELD'| translate }}
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-lg-12" style="font-size: 15px;">
                                    <p >{{ language == 'en'? 'Please create a new password that meets the following criteria:':'الرجاء إنشاء كلمة مرور جديدة تستوفي المعايير التالية:' }} </p>
                                    <ul>
                                        <li>
                                            <p >{{ language == 'en'? 'Must be at least 6 characters, Include numbers.':'يجب أن لا يقل عن 6 أحرف، بما في ذلك الأرقام.' }} </p>
                                        </li>
                                        <li>
                                            <p >{{ language == 'en'? 'Include at least one uppercase letter.':'قم بتضمين حرف كبير واحد على الأقل.' }} </p>
                                        </li>
                                        <!-- <li>
                                            <p >{{ language == 'en'? 'Contain special character (e.g., !, @, #, $).':'تحتوي على أحرف خاصة (على سبيل المثال، !، @، #، $)' }} </p>
                                        </li> -->
                                    </ul>
                                    
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input  type="checkbox" id="gridCheck" formControlName="Terms">
                                            <label style="margin: 0px 10px;" class="form-check-label" for="gridCheck">
                                                {{'AUTH.REGISTER.AGREE' | translate}} <a routerLink="/privacy-policy" target="_blank">{{'AUTH.REGISTER.TERMS' | translate}}</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="hasError">
                                    <div class="alert alert-danger d-flex align-items-center" role="alert">
                                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                            aria-label="Danger:">
                                            <use xlink:href="#exclamation-triangle-fill" />
                                        </svg>
                                        <div>
                                            {{ ErrorMessage }}
                                        </div>
                                    </div>
                                     <div *ngIf="GuestLink && Service !='BookAppointment' ">
                                        <p>{{ language == 'en'? 'You have no data?':'لا توجد لك بيانات ؟' }} <a style="cursor: pointer;color: rgb(182 142 39);" (click)="ShowGuestForm()">{{ language == 'en'? 'Register for the first time':'التسجيل لاول مرة'}}</a></p>

                                    </div>
                                </ng-container>
                                <div class="col-lg-12">
                                    <div class="text-center">
                                        <button type="button" (click)="SendOtpForPatient()" class="btn signup-btn">{{'AUTH.REGISTER.TITLE' |
                                            translate}}</button>
                                        <ng-container *ngIf="isLoading$ | async">
                                            <div class="spinner-border" role="status" style="margin-top: 30px;">
                                                <span class="visually-hidden"></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div *ngIf="Guest" class="col-lg-6 ptb-100">
                <div class="signup-item">
                    <div class="signup-head">
                        <h3>{{ language == 'en'? 'Register for the first time':'التسجيل لاول مرة'}}</h3>
                         <p>{{ language == 'en'? 'You have data?':' لديك بيانات ؟' }} <a style="cursor: pointer;color: rgb(182 142 39);" (click)="ShowPatientForm()">{{ language == 'en'? 'Sign Up':'التسجيل'}}</a></p>

                    </div>
                    <div class="signup-form">
                        <form class="login-form" [formGroup]="guestForm" >
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSPORTNO' | translate}}"
                                            formControlName="IqamaID" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'IqamaID',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                      
                                        <div class="text-danger" class="text-danger" *ngIf="!guestForm.get('IqamaID').valid && guestForm.get('IqamaID').touched">
                                            {{ language == 'en'? 'You must enter a valid National ID / Iqama (8-15) Characters':'يجب ادخال رقم هوية صحيح (8-15) حرفًا'}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="number" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PHONENUMBER' | translate}}"
                                            formControlName="Mobile" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Mobile',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="controlHasError('pattern', 'Mobile',guestForm)">
                                            {{ 'AUTH.VALIDATION.MOBILE_VALIDATION'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.FIRSTNAME' | translate}}"
                                            formControlName="FName" autocomplete="off" >
                                        <div class="text-danger" *ngIf="controlHasError('required', 'FName',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control"
                                            placeholder="{{'AUTH.INPUT.LASTNAME' | translate}}"
                                            formControlName="LName" autocomplete="off">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'LName',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="number" class="form-control"
                                            placeholder="{{'AUTH.INPUT.AGE' | translate}}"
                                            formControlName="Age" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Age',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="controlHasError('min', 'Age',guestForm)">
                                            {{ language == 'en'? 'You must enter a valid number':'يجب ادخال رقم صحيح'}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <select class="form-control" formControlName="Gender">
                                            <option value="">{{'AUTH.INPUT.GENDER' | translate}}</option>
                                            <option value="1">{{ language == 'en'? 'Male':'ذكر'}}</option>
                                            <option value="2">{{ language == 'en'? 'Female':'انثي'}}</option>
                                        </select>
                                
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Gender',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.PASSWORD' | translate}}"
                                            formControlName="Password">
                                        <div class="text-danger" *ngIf="controlHasError('required', 'Password',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        <div class="text-danger" *ngIf="!guestForm.get('Password').valid && guestForm.get('Password').touched">
                                            {{ 'AUTH.VALIDATION.PASSWORDCONS'| translate }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <input type="password" class="form-control"
                                            placeholder="{{'AUTH.INPUT.CONFIRM_PASSWORD' | translate}}"
                                            formControlName="ConfirmPassword" autocomplete="off" readonly
                                            onfocus="this.removeAttribute('readonly');">
                                        <div class="text-danger"
                                            *ngIf="controlHasError('required', 'ConfirmPassword',guestForm)  && isControlTouched('ConfirmPassword',guestForm)">
                                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                                        </div>
                                        
                                        <ng-container
                                            *ngIf="guestForm.controls['ConfirmPassword'].errors &&
                                            guestForm.controls['ConfirmPassword'].errors.ConfirmPassword && isControlTouched('ConfirmPassword',guestForm)">
                                            <div class="text-danger">
                                                {{ 'AUTH.VALIDATION.DIDNOTMATCH_FIELD'| translate }}
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="col-lg-12" style="font-size: 15px;">
                                    <p >{{ language == 'en'? 'Please create a new password that meets the following criteria:':'الرجاء إنشاء كلمة مرور جديدة تستوفي المعايير التالية:' }} </p>
                                    <ul>
                                        <li>
                                            <p >{{ language == 'en'? 'Must be at least 6 characters, Include numbers.':'يجب أن لا يقل عن 6 أحرف، بما في ذلك الأرقام.' }} </p>
                                        </li>
                                        <li>
                                            <p >{{ language == 'en'? 'Include at least one uppercase letter.':'قم بتضمين حرف كبير واحد على الأقل.' }} </p>
                                        </li>
                                        <!-- <li>
                                            <p >{{ language == 'en'? 'Contain special character (e.g., !, @, #, $).':'تحتوي على أحرف خاصة (على سبيل المثال، !، @، #، $)' }} </p>
                                        </li> -->
                                    </ul>
                                    
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <div class="form-check">
                                            <input  type="checkbox" id="gridCheck" formControlName="Terms">
                                            <label style="margin: 0px 10px;" class="form-check-label" for="gridCheck">
                                                {{'AUTH.REGISTER.AGREE' | translate}} <a routerLink="/privacy-policy" target="_blank">{{'AUTH.REGISTER.TERMS' | translate}}</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="hasError">
                                    <div class="alert alert-danger d-flex align-items-center" role="alert">
                                        <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                            aria-label="Danger:">
                                            <use xlink:href="#exclamation-triangle-fill" />
                                        </svg>
                                        <div>
                                            {{ ErrorMessage }}
                                        </div>
                                        
                                    </div>
                                   
                                </ng-container>
                                <div class="col-lg-12">
                                    <div class="text-center">
                                        <button type="button"  (click)="SendOtpForGuest()" class="btn signup-btn">{{'AUTH.REGISTER.TITLE' |
                                            translate}}</button>
                                        <ng-container *ngIf="isLoading$ | async">
                                            <div class="spinner-border" role="status" style="margin-top: 30px;">
                                                <span class="visually-hidden"></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalContent let-close="close" >
    <div class="text-center" style="padding: 15px;">
        <div class="row" style="margin: 30px 0px 20px 0px;">
          <div class="col-lg-12">
            <h3>{{'AUTH.INPUT.ENTERCODE' | translate}}</h3>
            <p>{{'AUTH.INPUT.ENTERCODEPARA' | translate}}</p>
          </div>
        </div>
        <div mat-dialog-content>
          <div class="signup-item">
            <div class="signup-form">
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4">
                    <div class="form-group">
                      <input type="text" class="form-control"
                        [(ngModel)]="OtpCode" autocomplete="off" >
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="text-center" style="margin-top: 30px;">
          <div class="col-lg-12">
            <div class="text-center">
              <button style="font-weight: bold;" type="button" class="btn btn-success" (click)="ValidateOtpCode()">{{ 'CONTACTUS.SEND' |
                translate }}</button>
              
              <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="onNoClick()">{{
                'COMMON.BACK' |
                translate }}</button><br>
                <ng-container *ngIf="isLoading$ | async">
                  <div class="spinner-border" role="status" style="margin-top: 30px;">
                    <span class="visually-hidden"></span>
                  </div>
                </ng-container>
            </div>
          </div>
        </div>
      </div>
</ng-template>
